import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import singleDiscount from 'images/icons/single-discount.webp';
import roundTripDiscount from 'images/icons/rounded-discount.webp';

/**
 * WelcomeDigitalDiscountMessage component.
 * @param {object} props - useTagShapeMobile.
 * @param {boolean} props.useTagShapeMobile - If true, use clipPath id `tagShapeMobile` and hide on large screens.
 * @returns {JSX.Element} The rendered component.
 */
const WelcomeDigitalDiscountMessage = ({ useTagShapeMobile = false }) => {
  const { t } = useTranslation('general');

  const clipPathId = useTagShapeMobile ? 'tagShapeMobile' : 'tagShape';
  return (
    <div
      className={`flex flex-col items-start drop-shadow-lg cursor-pointer ${
        useTagShapeMobile ? 'lg:hidden' : ''
      }`}
    >
      <div
        className="bg-white inline-flex items-center pr-3  w-full gap-1 py-1 pl-5 rounded-lg relative min-w-56 overflow-hidden"
        style={{
          clipPath: `url(#${clipPathId})`,
        }}
      >
        <svg
          className="absolute inset-0 w-full h-full"
          preserveAspectRatio="none"
          viewBox="0 0 100 100"
        >
          <defs>
            <clipPath id={clipPathId} clipPathUnits="objectBoundingBox">
              <path d="M 0.06 0 Q 0.045 0, 0.03 0.136 L 0 0.5 L 0.03 0.864 Q 0.045 1, 0.06 1 L 0.97 1 Q 1 1, 1 0.97 L 1 0.03 Q 1 0, 0.97 0 Z" />
            </clipPath>
          </defs>
        </svg>
        <div className="absolute left-2 top-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-white rounded-full shadow-inner border border-solid" />
        <p className="text-xs">
          <Trans
            t={t}
            i18nKey="internet_discount_message"
            components={{
              b: <b />,
            }}
          />
        </p>
        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1">
            <img src={singleDiscount} alt="" className="h-4 object-contain" />
            <span className="bg-primary-regular rounded-full py-1 px-2 text-xs text-white font-semibold">
              {t('departure')}
            </span>
          </span>
          <span className="text-lg font-bold text-primary-regular">+</span>
          <span className="flex items-center gap-1">
            <img src={roundTripDiscount} alt="" className="h-4 object-contain" />
            <span className="bg-accent-regular rounded-full py-1 px-2 text-xs text-white font-semibold">
              {t('return')}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

WelcomeDigitalDiscountMessage.propTypes = {
  useTagShapeMobile: PropTypes.bool,
};

export default WelcomeDigitalDiscountMessage;
